import type { BotaoBroadcast, EstadoBroadcast, EstadoDestinatario, ExtrasBroadcast, OrigemVariavel, ProblemaBroadcast, Publico, ResumoTemplate } from '@malgoos/shared';
import type { CorSelo } from '../../componentes/base';

/** U14 F5: tipos da aba Automações > Broadcast (o que a API devolve). */

/** Base das rotas do módulo (a aba é `${BASE}/broadcast` e a ficha, `${BASE}/disparo/:id`). */
export const BASE_BROADCAST = '/automacoes/automacoes';
export const chaveBroadcasts = ['automacoes', 'broadcasts'] as const;

export interface Contagem {
  total: number;
  pendentes: number;
  enviando: number;
  enviados: number;
  entregues: number;
  lidos: number;
  falhas: number;
  ignorados: number;
  cliques: number;
  saidas: number;
}

export interface BroadcastResumo {
  id: string;
  nome: string;
  estado: EstadoBroadcast;
  template_nome: string | null;
  tipo: 'avisos' | 'marketing' | null;
  agendado_para: string | null;
  iniciado_em: string | null;
  concluido_em: string | null;
  motivo: string | null;
  updated_at: string;
  contagem: Contagem;
}

export interface Broadcast {
  id: string;
  nome: string;
  estado: EstadoBroadcast;
  template: { nome: string; idioma: string; categoria: string | null; status: string | null; resumo: ResumoTemplate | null } | null;
  tipo: 'avisos' | 'marketing' | null;
  variaveis: OrigemVariavel[];
  extras: ExtrasBroadcast;
  botoes: BotaoBroadcast[];
  publico: Publico;
  planilha_colunas: string[];
  planilha_linhas: number;
  declaracao: string | null;
  declarado_por_nome: string | null;
  declarado_em: string | null;
  agendado_para: string | null;
  ritmo: number;
  limite_24h: number | null;
  motivo: string | null;
  iniciado_em: string | null;
  concluido_em: string | null;
  updated_at: string;
  problemas: ProblemaBroadcast[];
  contagem: Contagem;
  por_botao: { indice: number; cliques: number }[];
  por_erro: { codigo: number | null; total: number }[];
  por_motivo: { motivo: string; total: number }[];
  fluxos: { id: string; nome: string; estado: string; publicado: boolean }[];
  conversas: boolean;
}

export interface Destinatario {
  id: string;
  telefone: string;
  nome: string | null;
  parceiro_id: string | null;
  conversa_id: string | null;
  estado: EstadoDestinatario;
  motivo: string | null;
  erro_codigo: number | null;
  tentativas: number;
  despachado_em: string | null;
  entregue_em: string | null;
  lido_em: string | null;
  falhou_em: string | null;
  clicou_em: string | null;
  botao: number | null;
  saiu_em: string | null;
}

export interface Previa {
  resumo: {
    encontrados: number;
    recebem: number;
    sem_consentimento: number;
    saiu: number;
    telefone_invalido: number;
    repetido: number;
    variavel_vazia: number;
    acima_do_teto: boolean;
  };
  amostra: { nome: string; telefone: string; recebe: boolean; motivo: string | null; variaveis: string[] }[];
}

export interface Consentimento {
  id: string;
  contato: string;
  parceiro_id: string | null;
  parceiro_nome: string | null;
  tipo: 'avisos' | 'marketing';
  situacao: 'autorizou' | 'saiu';
  origem: string;
  declaracao: string | null;
  registrado_por_nome: string | null;
  em: string;
}

export interface TemplateOpcao {
  id: string;
  nome: string;
  idioma: string;
  categoria: string;
  status: string;
  corpo: string;
  componentes: unknown;
}

export const COR_ESTADO_BROADCAST: Record<EstadoBroadcast, CorSelo> = { rascunho: 'neutro', agendado: 'azul', enviando: 'ciano', pausado: 'laranja', concluido: 'verde', cancelado: 'neutro' };
export const COR_DESTINATARIO: Record<EstadoDestinatario, CorSelo> = { pendente: 'neutro', enviando: 'azul', enviado: 'azul', entregue: 'ciano', lido: 'verde', falhou: 'perigo', ignorado: 'neutro' };

/** Telefone para a tela: +55 (11) 98765-4321 no Brasil, +<dígitos> nos outros. */
export function telefoneTela(digitos: string): string {
  const m = /^55(\d{2})(\d{4,5})(\d{4})$/.exec(digitos);
  return m ? `+55 (${m[1]}) ${m[2]}-${m[3]}` : `+${digitos}`;
}
